import { LangContext } from './../layouts/index'
import React from 'react'
import { Link } from 'gatsby'
import { translateInternalUrlForLang } from '../utilities'

const getTranslatedLink = (lang, slug) => {
  return translateInternalUrlForLang(slug, lang)
}

export const TranslatedLink = (props) => {
  const { children, to, useNativeLink, ...otherProps } = props

  const langProp = props.lang
  return (
    <LangContext.Consumer>
      {(lang) => {
        const language = langProp != null ? langProp : lang

        if (useNativeLink) {
          return (
            <a href={getTranslatedLink(language, to)} {...otherProps}>
              {children}
            </a>
          )
        } else {
          return (
            <Link to={getTranslatedLink(language, to)} {...otherProps}>
              {children}
            </Link>
          )
        }
      }}
    </LangContext.Consumer>
  )
}
